import { ShieldCheck, Clock, Hammer, Award, Languages, Siren, BadgeCheck } from "lucide-react";

const reasons = [
  {
    icon: ShieldCheck,
    title: "Licensed & Insured",
    desc: "Operating as JJH Painting & Pressure Washing LLC — fully covered on every job.",
  },
  {
    icon: Clock,
    title: "Serving Since 2017",
    desc: "Nearly a decade of repeat customers and word-of-mouth referrals across Bay County.",
  },
  {
    icon: Hammer,
    title: "Real Local Crew",
    desc: "No subcontractors. The crew that quotes the job is the crew that does the work.",
  },
  {
    icon: Award,
    title: "Free In-Person Estimates",
    desc: "We come to you, walk the project, and quote it on the spot — Mon–Sat, 8a–5p.",
  },
];

const highlights = [
  { icon: BadgeCheck, label: "9+ Years of Experience" },
  { icon: Languages, label: "Se Habla Español" },
  { icon: Siren, label: "Emergency Services Offered" },
];

export default function About() {
  return (
    <section id="about" className="bg-[#FAFAFA] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">Why JJH</div>
          <h2 className="mt-3 font-heading font-black uppercase tracking-tight text-[#334155] text-4xl sm:text-5xl leading-[0.95]">
            Built On<br />Word-Of-Mouth.
          </h2>
          <p className="mt-6 text-base text-[#4B5563] leading-relaxed">
            We take great pride in our experience, expertise, quality, and customer
            service. It is our mission to provide excellent workmanship and complete
            customer satisfaction from the start to the completion of every project.
          </p>
          <p className="mt-4 text-base text-[#4B5563] leading-relaxed">
            To understand the needs and expectations of our customers, we take great
            care to work and communicate with every client in a professional manner.
            Our reputation is built on <span className="font-semibold text-[#334155]">service, safety, and quality</span> — no
            matter how large or small the job.
          </p>

          <div className="mt-8 flex flex-wrap gap-2.5">
            {highlights.map((h) => {
              const Icon = h.icon;
              return (
                <span
                  key={h.label}
                  className="inline-flex items-center gap-2 bg-[#334155] text-white px-3.5 py-2 text-[11px] font-bold uppercase tracking-[0.15em]"
                >
                  <Icon size={14} className="text-[#0EA5E9]" />
                  {h.label}
                </span>
              );
            })}
          </div>

          <div className="mt-10 border-l-4 border-[#0EA5E9] pl-6">
            <p className="font-heading font-bold uppercase tracking-tight text-[#334155] text-xl leading-tight">
              “If we wouldn’t paint it that way at our own house, we won’t paint it that way at yours.”
            </p>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wider text-[#4B5563]">
              — The JJH Crew
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {reasons.map((r) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                className="bg-white border-2 border-[#334155] p-6 sm:p-7 transition-transform hover:-translate-y-1"
              >
                <div className="h-12 w-12 bg-[#0EA5E9] grid place-items-center text-white">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-heading font-bold uppercase tracking-tight text-[#334155] text-xl">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-[#4B5563] leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
